import bsCustomFileInput from 'bs-custom-file-input';
import moment from 'moment';

const { default: axios } = require("axios");
const { set } = require("lodash");

require('admin-lte/plugins/tempusdominus-bootstrap-4/js/tempusdominus-bootstrap-4');

$(document).ready(function(){

    $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
        icons: {
            time: 'fa-solid fa-clock',
            date: 'fa-solid fa-calendar',
            up: 'fa-solid fa-arrow-up',
            down: 'fa-solid fa-arrow-down',
            previous: 'fa-solid fa-chevron-left',
            next: 'fa-solid fa-chevron-right',
            today: 'fa-solid fa-calendar-check-o',
            clear: 'fa-solid fa-trash',
            close: 'fa-solid fa-xmark'
        } 
    });

    init();
    window.onpopstate = window.ajax.onpopstate;

});

function init(){

    init_links();
    init_forms();
    init_tabs();

    init_coordinates();
    
    $('.set_locale').click(function(ev){
        ev.preventDefault();

        const locale = $(this).attr('locale');
        
        translations.setLocale(locale).then(() => {
            window.location.href = window.location.href;
        });

    });

    run_callback();

}

export function init_links(){

    $('a.ajax:not(.init)')
        .click(function(ev){
            ev.preventDefault();

            const href = $(this).attr('href');
            redirect(href);

            if($('body').hasClass('sidebar-open')){
                $('body').removeClass('sidebar-open').addClass(['sidebar-closed', 'sidebar-collapse']);
            }

        })
        .addClass('init');

}

function redirect(url, full_redirect, back){

    if(url == '' || url == '#'){
        return;
    }

    back = back || false;
    full_redirect = full_redirect || false;

    if(full_redirect){
        window.blockui = { release: function(){ console.log('ui locked!'); } };
        document.location.href = url;
        return;
    }

    const config = {
        headers: {
            Locale: window._locale,
            Layout: $('layout').length > 0 ? $('layout').attr('id') : '',
        }
    };

    axios
        .get(url, config)
        .then((response) => {

            if(!back){
                window.history.pushState({ 'ajax': true }, '', url);
            }

            parse_response(response);

        })
        .catch((error) => {

            if(error.response && error.response.status == 401){
                return redirect(window._url, true);
            }

            if(typeof error.response.data.message != 'undefined'){
                messages.error(error.response.data.message);
            } else {
                messages.error(error.response.statusText);
            }
            
        });

}

export function onpopstate(event){

    const full_redirect = 
        event.state == null
        || typeof event.state.ajax == 'undefined'
        || !event.state.ajax;

    redirect(document.location.href, full_redirect, true);

}

export function init_forms(){

    bsCustomFileInput.init();

    $('form.parsley').each(function(){
        $(this).removeClass('parsley');
        $(this).parsley();
    });

    $('input[type="password"]:not(.init)').each(function(){
        init_password_input($(this));
    });

    $('select.select2:not(.init)').each(function(){
        
        let options = {
            dropdownParent: $(this).attr('dropdownParent') ?? $(document.body),
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        };

        if(typeof $(this).attr('ajaxSource') != 'undefined' && $(this).attr('ajaxSource') != ''){
            options.ajax = {
                url: $(this).attr('ajaxSource'),
                dataType: 'json',
            };
        }

        $(this)
            .css('width', '100%')
            .select2(options);
            
        $(this).addClass('init');
        
    });

    $('textarea.tinymce:not(.init)').each(function(){
        window._tinymce.init($(this)[0]);
        $(this).addClass('init');
    });

    $('div.date.datetimepicker:not(.init)').each(function(){
        
        let date = $(this).find('input').val();
        date = date != '' ? moment(date, 'DD/MM/YYYY HH:mm:ss') : null;
        
        $(this).datetimepicker({
            locale: window._locale,
            format: 'DD/MM/YYYY HH:mm',
            defaultDate: date != null ? date : moment(),
            viewMode: 'days',
            keepOpen: true,
            // sideBySide: true,
        });
        $(this).addClass('init');

    });

    $('div.date.datepicker:not(.init)').each(function(){

        let date = $(this).find('input').val();
        date = date != '' ? moment(date, 'DD/MM/YYYY HH:mm:ss') : null;

        $(this).datetimepicker({
            locale: window._locale,
            format: 'DD/MM/YYYY',
            defaultDate: date != null ? date : moment(),
            viewMode: 'days',
        });
        $(this).addClass('init');

    });

    $('div.date.timepicker:not(.init)').each(function(){
        
        let date = $(this).find('input').val();
        date = date != '' ? moment(date, 'DD/MM/YYYY HH:mm:ss') : null;

        $(this).datetimepicker({
            locale: window._locale,
            format: 'HH:mm',
            defaultDate: date != null ? date : moment(),
            viewMode: 'days',
        });
        $(this).addClass('init');

    });
    
    $('button[type="submit"][form]:not(.init)').each(function(){
        init_submit_form($(this));
    });

    $('form.ajax:not(.init)')
        .submit(function(ev){
            ev.preventDefault();

            if($(this).hasClass('confirm')){

                let title = $(this).attr('confirm-title');
                if(typeof(title) == 'undefined'){
                    title = window.__('¿Estás seguro?');
                }

                let text = $(this).attr('confirm-text');
                if(typeof(text) == 'undefined'){
                    text = window.__('Esta acción no se puede deshacer');
                }

                messages.confirm(title, text).then(() => {
                    submit_form($(this));    
                });

            } else {
                submit_form($(this));
            }

        })
        .addClass('init');

    $("[autofocus]:visible:first").focus();
    window.init_translatable_fields();

}

function submit_form(form){

    // tinymce bug: https://stackoverflow.com/a/23312398
    tinymce.triggerSave(true, true); 

    const formData = new FormData(form[0]);
    const route = form.attr('action');
    const blockui = form.hasClass('blockui');

    post(route, formData, blockui);

}

export function post(route, formData, blockui, returnPromise){

    if(typeof blockui != 'undefined' && blockui){
        window.blockui.block();
    }

    const config = {
        headers: {
            Locale: window._locale,
            Layout: $('layout').length > 0 ? $('layout').attr('id') : '',
        }
    };

    let post = axios.post(route, formData, config);

    if(typeof returnPromise != 'undefined' && returnPromise){
        return post;
    }

    post
        .then((response) => {

            parse_response(response);

        })
        .catch((error) => {

            if(error.response && error.response.status == 401){
                return redirect(window._url, true);
            }

            if(typeof error.response.data.errors != 'undefined'){
                for(let error_key in error.response.data.errors){

                    for(let msg of error.response.data.errors[error_key]){
                        messages.error(msg);
                    }

                }
            } else {

                if(typeof error.response.data.message != 'undefined'){
                    messages.error(error.response.data.message);
                } else {
                    messages.error(error.response.statusText);
                }

            }
            
        })
        .finally(() => {

            if(window.blockui.blocked){
                window.blockui.release();
            }

        });

}

function parse_response(response){

    if(typeof response.data.success != 'undefined'){
        messages.success(response.data.success);
    }

    if(typeof response.data.info != 'undefined'){
        messages.info(response.data.info);
    }

    if(typeof response.data.error != 'undefined'){
        messages.error(response.data.error);
    }

    if(typeof response.data.warning != 'undefined'){
        messages.warning(response.data.warning);
    }

    if(typeof response.data.layout_id != 'undefined'){
        
        if(response.data.layout_id != '' && response.data.layout_id == $('layout').attr('id')){
            
            if(typeof response.data.sections != 'undefined'){

                $('section.ajax').each(function(){

                    if(typeof response.data.sections[$(this).attr('id')] != 'undefined'){

                        // dispose any datatable contained
                        $(this).find('table.dataTable').each(function(){
                            if($.fn.DataTable.isDataTable($(this))){
                                $(this).dataTable().remove(true);
                            }
                        });

                        $(this).html(response.data.sections[$(this).attr('id')]);

                    }

                });

            }

        } else {

            // if(typeof response.data.layout_content != 'undefined' && response.data.layout_content != ''){
            //
            //     $('layout').attr('id', response.data.layout_id).html(response.data.layout_content);
            //
            // } else {

                return redirect(document.location.href, true);

            // }

        }

    }

    if(typeof response.data.active_menu != 'undefined'){
        window.menu.select(response.data.active_menu);
    }

    if(typeof response.data.redirect != 'undefined'){
        const full_redirect = typeof response.data.full_redirect != 'undefined' && response.data.full_redirect;
        if(response.data.redirect != document.location.href || full_redirect){
            return redirect(response.data.redirect, full_redirect);
        }
    }

    init();

    if(typeof response.data.callback != 'undefined'){
        let callback_params = typeof response.data.callback_params != 'undefined' ? response.data.callback_params : [];
        run_callback(response.data.callback, callback_params);
    }

}

function init_custom_file_input(input){

    input.closest('.input-group').find('.examinar').click(function(){
        input.trigger('click');
    });

    input.addClass('init');

}

function init_submit_form(input){
    
    const form = $('form#' + input.attr('form'));
    const name = input.attr('name');
    const value = input.attr('value');
    
    if(
        form.length > 0 
        && typeof(name) != 'undefined' && name != ''
        && typeof(value) != 'undefined'
    ){

        const hidden_input = form.find('input[type="hidden"][name="' + name + '"]');
        if(hidden_input.length == 0){
            $('<input type="hidden" name="' + name + '">').prependTo(form);
        }

        input.click(function(){
            $('form#' + $(this).attr('form') + ' input[type="hidden"][name="' + $(this).attr('name') + '"]').val($(this).attr('value'));
        });

    }

    input.addClass('init');

}

function init_password_input(input){

    let parent = input.parent();
    let input_group_text = parent.find('.input-group-text');

    if(input_group_text.length == 0){
        
        let div = $('<div class="input-group"><div class="input-group-append"><span class="input-group-text"></span></div></div>');
        input.detach().prependTo(div);
        parent.append(div);

        input_group_text = parent.find('.input-group-text');

    }

    input_group_text
        .addClass('toggle_password')
        .html('<span class="fas fa-lock"></span>')
        .click(function(){
        
            var input = $(this).closest('.input-group').find('input');
            if(input.attr('type') == 'password'){
                
                input.attr('type', 'text');
                input.parent().find('.fas').removeClass('fa-lock').addClass('fa-unlock');

            } else {

                input.attr('type', 'password');
                input.parent().find('.fas').removeClass('fa-unlock').addClass('fa-lock');

            }

        });

    input.addClass('init');

}

function init_tabs(){

    $('.nav-tabs:not(.init), .nav-pills:not(.init)')
        .addClass('init')
        .find('a').bind('shown.bs.tab', function(event){
            
            const a = $(event.currentTarget);
            const panes = $(a.attr('href'));

            for(let pane of panes){

                $(pane).find('table.dataTable').each(function(){
                    if($.fn.DataTable.isDataTable($(this))){
                        $(this).dataTable().fnAdjustColumnSizing();
                    }
                });
                
            }
            
        });

}

function run_callback(callback, callback_params){
    
    if(typeof callback == 'undefined' && typeof callback_params == 'undefined'){
        callback = window._callback;
        callback_params = window._callback_params;
    }

    window._callback = '';
    window._callback_params = '';

    if(
        typeof callback == 'string' 
        && callback != '' 
    ){

        let callbacks = window.app;
        let _callback = callback.split('.');

        while(_callback.length > 1){
            
            let part = _callback.shift();
            if(typeof callbacks[part] != 'undefined'){

                callbacks = callbacks[part];

            } else {

                _callback = [null];
                break;

            }

        }

        if(
            _callback.length == 1 
            && _callback != null
            && typeof callbacks[_callback] == 'function'
        ){
            callbacks[_callback](callback_params);
        }

    }

}

function init_coordinates(){
    $('.x-form-input.coordinates:not(.init)').each(function(){
        window.coordinates.init_control($(this));
    });
}